<template>
  <v-card flat class="pa-2 mb-2 request-summary">

    <h4 class="section-title">Request summary:</h4>

    <v-row dense class="request-info">
      <v-col cols="12" sm="3">
        <span class="label-small"><strong>Country:</strong> {{ request.country }}</span>
      </v-col>

      <v-col cols="12" sm="3">
        <span class="label-small"><strong>Sales organisation:</strong> {{ request.salesOrganisation }}</span>
      </v-col>

      <v-col cols="12" sm="3">
        <span class="label-small"><strong>SBM profile:</strong> {{ request.sbmProfile }}</span>
      </v-col>

      <v-col cols="12" sm="3">
        <span class="label-small"><strong>Language:</strong> {{ request.language }}</span>
      </v-col>
    </v-row>

    <h5 class="label-small" style="margin-top: 2px; margin-left: 12px;">Requested models</h5>

    <v-row dense class="table-indent">
      <v-col cols="12" sm="4">
        <v-simple-table dense>
          <thead>
            <tr>
              <th>Model</th>
              <th>Serial</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(m, i) in request.modelSerials" :key="i">
              <td>{{ m.model }}</td>
              <td>{{ m.serial }}</td>
            </tr>
          </tbody>
        </v-simple-table>
      </v-col>
    </v-row>

  </v-card>
</template>

<script>
export default {
  name: "RequestSummary",
  props: {
    request: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style scoped>
.label-small {
  font-size: 12px;
}

.request-info {
  padding-left: 10px;
  row-gap: 6px;
}

.table-indent {
  padding-left: 12px;
}
</style>
